/**
 * Shorter form of a widget descriptor ("Bookings • Sum of group size • Last 30 days (Jul 27 - Aug 25) • All groups")
 * for tiles too narrow to show the full line even at the minimum font size: strips the
 * parenthetical date range and, when a source prefix is present (four parts), drops it.
 * The full text stays available on hover (title attribute) in the tile.
 */
export function shortenWidgetDescription(full) {
  if (!full) return '';
  let parts = String(full).split(' • ').map(p => p.replace(/\s*\([^)]*\)/g, '').trim()).filter(Boolean);
  // Only a four-part descriptor carries a source prefix (Source • Measure • Range • Scope);
  // three-part ones start with the measure, which must survive.
  if (parts.length >= 4) parts = parts.slice(1);
  return parts.join(' • ');
}
